import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import useWindowSize from '@rehooks/window-size';

import StandardButton from 'modules/shared/components/StandardButton/StandardButton';
import ReturnButton from 'modules/shared/components/ReturnButton/ReturnButton';

import { BLUE_BORDER } from 'constants/index';

import screen7 from 'static/assets/manual-screen-7.png';
import phone14 from 'static/assets/phone-14.png';

const ManualPageStepCooperation2 = ({ returnBack }) => {
  const windowSize = useWindowSize();
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    setIsRendered(true);
  }, []);

  return (
    <div className="manual-page__content-wrap">
      <CSSTransition
        classNames="animation-manual"
        in={isRendered}
        timeout={{ enter: 100, exit: 100, enterDelay: 100 }}
        unmountOnExit
      >
        <div className="manual-page__content manual-page__col">
          <ReturnButton onClick={returnBack} className="manual-page__return-link" />

          <div className="manual-page__text-list">
            <div className="manual-page__text">
              Если вы планируете принимать деньги за услуги от компании на свою карту, компания
              должна направить запрос на сотрудничество в ваш кошелёк.
            </div>
            <div className="manual-page__text">
              После этого, вы получите СМС с кодом и push-сообщение в кошельке. Чтобы подтвердить
              согласие на сотрудничество нужно сообщить этот код компании.
            </div>
          </div>

          {windowSize.innerWidth <= 760 && (
            <div className="manual-page__images-container">
              <img src={phone14} alt="" className="manual-page__phone manual-page__phone_14" />
              <img src={screen7} alt="" className="manual-page__screen manual-page__screen_7" />
            </div>
          )}

          <div className="manual-page__button-list">
            <StandardButton
              title="Перейти в кошелек"
              isLink
              href="/"
              className="manual-page__button-item"
              bgType={BLUE_BORDER}
            />
          </div>
        </div>
      </CSSTransition>

      <CSSTransition
        classNames="animation-manual"
        in={isRendered && windowSize.innerWidth > 760}
        timeout={{ enter: 100, exit: 100, enterDelay: 100 }}
        unmountOnExit
      >
        <div className="manual-page__col">
          <img src={phone14} alt="" className="manual-page__phone manual-page__phone_14" />
          <img src={screen7} alt="" className="manual-page__screen manual-page__screen_7" />
        </div>
      </CSSTransition>
    </div>
  );
};

ManualPageStepCooperation2.propTypes = {
  returnBack: PropTypes.func.isRequired,
};

export default ManualPageStepCooperation2;
